import React from 'react';
import { SelectPaymentType as SelectPaymentTypeBase } from '../../../submitCase/components/SelectPaymentType';
import { useActor } from '@xstate/react';
import { User } from 'firebase/auth';
import { State } from 'xstate';
import {
  EditPaymentContext,
  EditPaymentEvent,
} from '../../../../stateMachines/editPayment';
import { useHistory } from 'react-router-dom';
import useGoBackToCase from '../../../../hooks/useGoBackToCase';

interface SelectPaymentTypeProps {
  currentUser: User;
  state: State<
    EditPaymentContext,
    EditPaymentEvent,
    any,
    {
      value: any;
      context: EditPaymentContext;
    }
  >;
  send: (event: EditPaymentEvent) => void;
}

const SelectPaymentType: React.FC<SelectPaymentTypeProps> = ({
  state,
  send,
}) => {
  const history = useHistory();
  const isLoading = state.matches({ selectPaymentType: 'load' });
  const userCase = state.context.case!;
  // If this case is already invoiced, let user keep invoice status
  const hasPastDueInvoice = userCase.invoiceAccount
    ? false
    : state.context.hasPastDueInvoice;
  const goBack = useGoBackToCase();

  return (
    <SelectPaymentTypeBase
      title="Edit Payment Type"
      value={state.context.paymentType}
      onChange={(value) => {
        send({ type: 'SET_PAYMENT_TYPE', paymentType: value });
      }}
      onNext={() => send({ type: 'NEXT' })}
      onBack={() => goBack(userCase.id)}
      isLoading={isLoading}
      hasPastDueInvoice={hasPastDueInvoice}
      invoicingDisabled={false} // TODO
    />
  );
};

export default SelectPaymentType;
